import Vue from 'vue'
import { baseURL } from '../config'
//出入金记录 
export const kin_list = data => Vue.prototype.getAxios(baseURL + "/index.php", data)